import { Box, Button, Grid, Paper, Stack, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import companyLogo from '../../../images/companyLogo.jpg';
import { useNavigate } from 'react-router-dom';

function JobCard({ job }) {
    const [selectedOption, setSelectedOption] = useState('');
    const theme = useTheme();
    const handleChange = () => {
        setSelectedOption();
    };

    const DaysAgo = (date) => {
        if (date) {
            const inputDate = new Date(date);
            const currentDate = new Date();
            const timeDifference = currentDate.getTime() - inputDate.getTime();
            const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            return daysAgo;
        }
    }

    const navigate = useNavigate();
    return (

        <Paper sx={{ mx: 2, boxShadow: '0px 8px 64px rgba(54, 101, 208, 0.14)' }}>
            <Grid container py={2} px={2}>
                <Grid item xs={12} md={3}>
                    <img src={job?.logoUrl} style={{ borderRadius: '1rem' }} width={'100%'} alt='image' />
                </Grid>
                <Grid item xs={12} md={6} px={2}>
                    <Stack
                        sx={{
                            ...(theme.breakpoints.down('md') && {
                                my: 2, // Apply vertical margin for mobile view
                            }),
                        }}>
                        <Typography variant="body2" className='tex2Bold' sx={{ fontWeight: 'bold', cursor: 'pointer' }} onClick={() => navigate('/candidate/job-view/' + job?._id)}>{job?.jobTitle}</Typography>
                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%' }}>{job?.companyName}</Typography>
                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', opacity: '0.5' }}>{job?.city}, {job?.state}, {job?.country}</Typography>
                        <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#2544EE' }}>{job?.companyWebsite}</Typography>
                    </Stack>
                </Grid>
                <Grid md={2} sx={{ textAlign: 'right' }}>
                    <Typography variant="caption" className='tex2Bold' sx={{

                        backgroundColor: '#41B249',
                        fontWeight: 'bold', width: 'fit-content', color: '#fff',
                        borderRadius: '8px', textAlign: 'center', py: 1, px: 3
                    }}>
                        New
                    </Typography>
                </Grid>
                <Grid item xs={12} md={1} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }} >
                    <BookmarkBorderIcon />
                    <Typography variant="caption" className='tex2Bold' sx={{ fontWeight: 'bold', width: '100%', color: '#41B249' }}>{DaysAgo(job?.createdAt) == 0 ? "Today" : `${DaysAgo(job?.createdAt)} days ago`}</Typography>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default JobCard